import LocalStorageFactory from '@/factories/local-storage-factory'
import AgentApi from '@/api/agent-api'
import { get } from 'lodash'

const getAgentList = async () => {
  const cacheVersion = LocalStorageFactory.getAgentListCacheVersion()

  const agentResult = await AgentApi.list(cacheVersion)
  const isAgentListUpToDate = get(agentResult, 'isUpToDate', true)

  if (!isAgentListUpToDate) {
    const newVersion = get(agentResult, 'version', 0)
    const newAgentList = get(agentResult, 'agentList', [])

    LocalStorageFactory.setAgentList(newAgentList)
    LocalStorageFactory.setAgentListCacheVersion(newVersion)
  }

  const agentList = LocalStorageFactory.getAgentList()

  return agentList
}

export default {
  getAgentList
}
